import { Button, Panel } from '@routable/components';
import React from 'react';
export const WatchlistHit = ({ onOpenDetails, type, title }) => {
    return (React.createElement(Panel.Entry, { className: "flex justify-between items-center" },
        React.createElement(Panel.Item, { label: type === 'adverse_media' ? 'Adverse media' : 'Watchlist' }, title),
        React.createElement(Button, { "data-testid": `watchlist-hit-details__${title}`, onPress: onOpenDetails, size: "small", variant: "outline" }, "Details")));
};
